<template>
  <div class="ifizxfg">
    <div class="lantit">民商法类最新法规</div>
    <div class="top between mt30">
      <div class="topitem" v-for="item in 3" :key="item">
        <div class="cove">
          <img src="../../../assets/tiaolidetail/fgcover_sample.png" />
        </div>
        <div class="tit ellipsis">中华人民共和国婚姻法</div>
        <div class="des">
          {{
            `1980年9月10日第五届全国人民代表大会第三次会议通过根据2001年4月
          1980年9月10日第五届全国人民代表大会第三次会议通过根据2001年4月`
              | toEllipsisFilter(35)
          }}
        </div>
      </div>
    </div>
    <div class="botm between wrap">
      <div class="botomitem" v-for="item in 6" :key="item">
        最高人民法院关于审理国家赔偿案件确定精神...
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.ifizxfg {
  width: 100%;
  height: 100%;
  background: #ffffff;
  padding: 21px 32px 21px;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  border-radius: 2px;
  .lantit {
    font-size: 24px;
    color: #333333;
  }
  .top {
    align-items: flex-start;
    .topitem {
      cursor: pointer;
      width: 246px;
      &:hover {
        .tit {
          color: #0465ea;
        }
      }
      .cove {
        img {
          width: 246px;
          height: 174px;
          border-radius: 2px;
        }
      }
      .tit {
        margin-top: 14px;
        font-size: 16px;
        color: #333333;
        line-height: 16px;
      }
      .des {
        margin-top: 12px;
        font-size: 14px;
        color: #666666;
        line-height: 24px;
      }
    }
  }
  .botm {
    align-items: flex-start;
    color: #333;
    .botomitem {
      cursor: pointer;
      font-size: 16px;
      line-height: 16px;
      min-width: 280px;
      margin-top: 24px;
      padding-left: 15px;
      position: relative;
      &:hover {
        color: #0465ea;
        &::before {
          background-color: #0465ea;
        }
      }
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        width: 6px;
        height: 6px;
        background: #b5b5b5;
        border-radius: 50%;
      }
    }
  }
}
</style>